import axios from 'axios'
import config from '../config/config'

// a chave do Google Maps fica somente no appsettings.json (GoogleMapsConfiguration:ApiKey)
// e é carregada uma única vez, na inicialização da aplicação (index.js)
let apiKey = ''

export const googleMapsService = {
  loadApiKey,
  getApiKey
}

function loadApiKey() {
  return axios
    .get(config.baseUrl + 'configuracoes/googleMaps')
    .then((response) => {
      apiKey = response.data?.apiKey || ''
    })
    .catch((error) => {
      console.error('Não foi possível obter a chave do Google Maps: ', error)
    })
}

function getApiKey() {
  return apiKey
}
